import { library } from '@fortawesome/fontawesome-svg-core';
import * as fas from '@fortawesome/pro-solid-svg-icons';
import * as far from '@fortawesome/pro-regular-svg-icons';
import * as fal from '@fortawesome/pro-light-svg-icons';
import * as fad from '@fortawesome/pro-duotone-svg-icons';
import { IconProp, IconDefinition } from '@fortawesome/fontawesome-svg-core';

library.add(fal.faSearch as IconDefinition);
library.add(fal.faQuestionCircle as IconDefinition);
library.add(fal.faHistory as IconDefinition);
library.add(fal.faFileSearch as IconDefinition);
library.add(fal.faThList as IconDefinition);
library.add(fal.faListUl as IconDefinition);
library.add(fal.faTimes as IconDefinition);
library.add(fal.faDownload as IconDefinition);
library.add(fal.faEye as IconDefinition);
library.add(fal.faSync as IconDefinition);
library.add(fal.faRedo as IconDefinition);
library.add(fal.faTrashAlt as IconDefinition);
library.add(fal.faClock as IconDefinition);
library.add(fal.faFolderOpen as IconDefinition);
library.add(fal.faChartBar as IconDefinition);
library.add(fal.faChartPie as IconDefinition);
library.add(fal.faUserCircle as IconDefinition);
library.add(fal.faCog as IconDefinition);
library.add(fal.faExclamationTriangle as IconDefinition);
library.add(fal.faPlus as IconDefinition);
library.add(fal.faMinus as IconDefinition);
library.add(fal.faGlobe as IconDefinition);
library.add(fal.faMinusCircle as IconDefinition);
library.add(fal.faCommentDots as IconDefinition);
library.add(fal.faPlusCircle as IconDefinition);
library.add(fal.faEdit as IconDefinition);
library.add(fal.faArchive as IconDefinition);
library.add(fal.faEllipsisH as IconDefinition);
library.add(fal.faCaretDown as IconDefinition);
library.add(fal.faFileExport as IconDefinition);
library.add(fal.faCheckCircle as IconDefinition);
library.add(fal.faInfoCircle as IconDefinition);
library.add(fas.faStar as IconDefinition);
library.add(fas.faExclamationTriangle as IconDefinition);
library.add(fas.faCaretDown as IconDefinition);
library.add(fas.faCaretUp as IconDefinition);
library.add(fas.faTimesCircle as IconDefinition);
library.add(far.faChevronLeft as IconDefinition);
library.add(far.faChevronRight as IconDefinition);
library.add(far.faSlidersH as IconDefinition);
library.add(far.faPrint as IconDefinition);
library.add(far.faCheck as IconDefinition);
library.add(fal.faImage as IconDefinition);
library.add(fal.faInfoCircle as IconDefinition);
library.add(far.faExclamationTriangle as IconDefinition);
library.add(fal.faHourglassHalf as IconDefinition);
library.add(fal.faPlayCircle as IconDefinition);
library.add(fal.faStopCircle as IconDefinition);
library.add(fal.faUser as IconDefinition);
library.add(fal.faStar as IconDefinition);
library.add(far.faRedoAlt as IconDefinition);
library.add(fal.faEllipsisV as IconDefinition);
library.add(far.faListUl as IconDefinition);
library.add(fal.faThList as IconDefinition);
library.add(fal.faAngleDown as IconDefinition);
library.add(far.faChevronDown as IconDefinition);
library.add(fas.faCaretRight as IconDefinition);
library.add(fal.faUpload as IconDefinition);
library.add(fas.faTools as IconDefinition);
library.add(fal.faListAlt as IconDefinition);
library.add(fas.faQuestionCircle as IconDefinition);
library.add(fal.faShapes as IconDefinition);
library.add(fas.faBookmark as IconDefinition);
library.add(fal.faBookmark as IconDefinition);
library.add(fal.faCogs as IconDefinition);
library.add(fal.faSave as IconDefinition);
library.add(fas.faSortDown as IconDefinition);
library.add(fal.faAnalytics as IconDefinition);
library.add(fal.faUnlockAlt as IconDefinition);
library.add(fal.faBellPlus as IconDefinition);
library.add(fal.faFilter as IconDefinition);
library.add(fal.faTable as IconDefinition);
library.add(far.faArrowUp as IconDefinition);

export const faAnalyticsPro = fad.faAnalytics as IconProp;
export const faBellPro = fad.faBell as IconProp;
export const faInfoCircle = fad.faInfoCircle as IconProp;
export const faCogs = fad.faCogs as IconProp;
export const faUnlockAlt = fad.faUnlockAlt as IconProp;
export const faUserCircle = fad.faUserCircle as IconProp;
export const faQuestion = fad.faQuestion as IconProp;
export const faQuestionCircle = fad.faQuestionCircle as IconProp;
export const faExclamationTriangle = fad.faExclamationTriangle as IconProp;
export const faTable = fad.faTable as IconProp;

//const iconsPro = fad.faAnalytics  as IconProp;

